export enum ALLOWANCE_STATUS {
    ERROR = 'error',
    SUCCESS = 'success',
    PROCESSING = 'processing',
    WARNING = 'warning',
    WAITING = 'waiting',
}
